import { AuthenticationContext } from '@/context/AuthenticationProvider';
import { useContext } from 'react';

export const useAuthentication = () => {
  const context = useContext(AuthenticationContext);
  return context;
};
